import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import App from "./component/index/App.jsx";
import Titulo from "./component/index/Titulo.jsx";
import WTCrossExplain from "./component/index/ExplicacionWabe.jsx";
import TickerFijo from "./component/index/tikner.jsx";
import FinancialFooter from "./component/index/FinancialFooter.jsx";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <div className="min-h-screen flex flex-col bg-slate-900 text-white overflow-x-hidden">

      {/* Ticker fijo arriba */}
      <TickerFijo />

      {/* Contenido principal */}
      <main className="flex-1 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 space-y-10">
        <Titulo />
        <App />
        <WTCrossExplain />
      </main>

      {/* Footer */}
      <FinancialFooter />

    </div>
  </React.StrictMode>
);